import { defineStore } from "pinia";
import type { IPlanManageItem, IPlanManageRepository } from "~/interfaces/IPlanManageRepository";
import { PlanManageRepository } from "~/repositories/PlanManageRepository";

export const usePlanManageStore = defineStore("PlanManageStore", () => {
  const plans = ref<IPlanManageItem[]>();

  const loading = ref(false);

  const repository: IPlanManageRepository = new PlanManageRepository();

  const fetch = async () => {
    loading.value = true;
    try {
      const res = await repository.fetch();
      plans.value = res.plans;
    } finally {
      loading.value = false;
    }
  };

  const updateMenuSort = async (planId: string, menuSort: Record<string, number>) => {
    try {
      await repository.updateMenuSort(planId, menuSort);
    } catch (error) {
      sentryErrorLog(`メニュー並び替えエラー: ${error}`);
    }
  };

  return {
    plans,
    loading,
    fetch,
    updateMenuSort,
  };
});
